/**
 * Chọn chỗ lưu token: phiên thường ở `localStorage` (mọi tab dùng chung), tab
 * "đăng nhập thay" ở `sessionStorage` (chỉ tab đó thấy).
 *
 * Bất biến cần giữ (có test ở tests/tokenStore.test.cjs): khi cờ `impersonation`
 * đang bật, tab KHÔNG BAO GIỜ đọc/ghi/xoá token của admin trong `localStorage`.
 * Cờ cố ý không bị `clearTokens` xoá — token hết hạn thì tab vẫn biết mình là tab
 * đăng nhập thay, không rơi về token admin rồi chạy API dưới tên super admin trong
 * khi giao diện còn hiện nhân viên.
 */
const ACCESS_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';
const IMP_FLAG_KEY = 'impersonation';
const IMP_TOKEN_KEY = 'impersonation_access_token';

function safe(fn, fallback = null) {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
}

function createTokenStore(local, session) {
  const impersonating = () => safe(() => session.getItem(IMP_FLAG_KEY) === '1', false);

  return {
    isImpersonating: impersonating,

    getAccessToken() {
      if (impersonating()) return safe(() => session.getItem(IMP_TOKEN_KEY));
      return safe(() => local.getItem(ACCESS_KEY));
    },

    // Token đăng nhập thay không có refresh — hết 60 phút là hết.
    getRefreshToken() {
      if (impersonating()) return null;
      return safe(() => local.getItem(REFRESH_KEY));
    },

    setTokens(accessToken, refreshToken) {
      if (impersonating()) return;
      local.setItem(ACCESS_KEY, accessToken);
      local.setItem(REFRESH_KEY, refreshToken);
    },

    clearTokens() {
      if (impersonating()) {
        safe(() => session.removeItem(IMP_TOKEN_KEY));
        return;
      }
      local.removeItem(ACCESS_KEY);
      local.removeItem(REFRESH_KEY);
    },

    hasAccessToken() {
      return !!this.getAccessToken();
    },

    startImpersonation(accessToken) {
      session.setItem(IMP_FLAG_KEY, '1');
      session.setItem(IMP_TOKEN_KEY, accessToken);
    },
  };
}

/** Token trong fragment `#token=...` của trang /impersonate, hoặc null. */
function tokenFromHash(hash) {
  const m = /(?:^#|&)token=([^&]+)/.exec(hash || '');
  return m ? decodeURIComponent(m[1]) : null;
}

module.exports = { createTokenStore, tokenFromHash, IMP_FLAG_KEY, IMP_TOKEN_KEY };
